const MAX_MESSAGE_LEN = 50;

export function normalizeSwishPhone(raw) {
  if (raw == null) return null;
  const digits = String(raw).replace(/\D/g, "");
  if (!digits) return null;
  if (digits.startsWith("46") && digits.length === 11) return digits;
  if (digits.startsWith("0") && digits.length === 10) return `46${digits.slice(1)}`;
  return null;
}

export function validateSwishPhone(raw) {
  if (raw == null || !String(raw).trim()) return { phone: null, error: null };
  const phone = normalizeSwishPhone(raw);
  if (!phone || !/^467\d{8}$/.test(phone)) {
    return { phone: null, error: "invalid" };
  }
  return { phone, error: null };
}

export function swishPayeeLocal(normalized) {
  if (!normalized || !normalized.startsWith("46") || normalized.length !== 11) return null;
  return `0${normalized.slice(2)}`;
}

export function buildSwishMessage(projectName) {
  const name = (projectName || "").trim();
  if (!name) return "Grupptipset";
  const msg = `Grupptipset: ${name}`;
  return msg.length <= MAX_MESSAGE_LEN ? msg : msg.slice(0, MAX_MESSAGE_LEN);
}

function buildSwishPaymentPayload(normalized, amountSek, message) {
  const localPayee = swishPayeeLocal(normalized);
  if (!localPayee) return null;
  const amountInt = Math.max(0, Math.round(Number(amountSek) || 0));
  if (amountInt <= 0) return null;
  const msg = (message || buildSwishMessage("")).slice(0, MAX_MESSAGE_LEN);
  return {
    version: 1,
    payee: { value: localPayee, editable: false },
    amount: { value: amountInt, editable: false },
    message: { value: msg, editable: false },
  };
}

/** C-format string for Swish QR scanner, e.g. C0701234567;200;Message;0 */
export function buildSwishQrContent({ phone, amountSek, message, currencyCode = "SEK" }) {
  if ((currencyCode || "").trim().toUpperCase() !== "SEK") return null;
  const { phone: normalized, error } = validateSwishPhone(phone);
  if (error || !normalized) return null;
  const payload = buildSwishPaymentPayload(normalized, amountSek, message);
  if (!payload) return null;
  const { value: localPayee } = payload.payee;
  const { value: amountInt } = payload.amount;
  const { value: msg } = payload.message;
  return `C${localPayee};${amountInt};${msg};0`;
}

/** swish:// deep link with URL-encoded JSON (not base64). */
export function buildSwishPaymentUrl({ phone, amountSek, message, currencyCode = "SEK" }) {
  if ((currencyCode || "").trim().toUpperCase() !== "SEK") return null;
  const { phone: normalized, error } = validateSwishPhone(phone);
  if (error || !normalized) return null;
  const payload = buildSwishPaymentPayload(normalized, amountSek, message);
  if (!payload) return null;
  const data = JSON.stringify(payload);
  return `swish://payment?data=${encodeURIComponent(data)}`;
}

export function formatSwishPhoneDisplay(normalized) {
  if (!normalized || !normalized.startsWith("46") || normalized.length !== 11) {
    return normalized || "";
  }
  const local = `0${normalized.slice(2)}`;
  return `${local.slice(0, 3)}-${local.slice(3, 6)} ${local.slice(6, 8)} ${local.slice(8, 10)}`;
}

/** Display-friendly input from stored normalized phone. */
export function swishPhoneToInputValue(stored) {
  if (!stored) return "";
  return formatSwishPhoneDisplay(stored) || stored;
}
